
import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

const BlueprintCoursePreview: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-techne-primaryPurple mb-4">
              BoardSight Blueprint
            </h2>
            <p className="text-xl mb-6 text-gray-600">
              The fastest path for directors to master AI governance & risk—in just 12 hours of bite‑size content.
            </p>
            <p className="text-gray-600 mb-6">
              Join our next cohort beginning December 1, 2025 and gain the expertise needed to lead with confidence in the AI era.
            </p>
            <Link 
              to="/blueprint" 
              className="btn-primary inline-flex items-center"
            >
              Learn More About The Course
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </Link>
          </div>
          
          <div className="relative">
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-techne-purple/20 rounded-full blur-xl"></div>
            <Card className="overflow-hidden shadow-lg">
              <CardContent className="p-0">
                <img
                  src="/lovable-uploads/35872c79-84a1-4653-910e-93c6ceddd32a.png"
                  alt="BoardSight Blueprint Course"
                  className="w-full h-auto"
                />
                <div className="p-6">
                  <div className="text-sm font-medium text-white bg-techne-purple inline-flex rounded-full px-3 py-1 mb-4">
                    Join December 1, 2025 Cohort
                  </div>
                  <h3 className="text-xl font-semibold mb-2">Master AI Governance</h3>
                  <p className="text-gray-600">
                    Comprehensive training for board directors responsible for AI oversight
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlueprintCoursePreview;
